import axios, { AxiosInstance, AxiosResponse } from "axios";

// 1. Define your API Base URL (Ideally loaded from environment variables)
const API_BASE_URL = process.env.REACT_APP_API_URL;

// 2. Create the custom Axios instance
export const apiClient: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// 4. Response Interceptor (Runs AFTER a response arrives, but before your service sees it)
apiClient.interceptors.response.use(
  (response: AxiosResponse) => {
    // You can modify or just pass through successful responses (e.g., 200, 201)
    return response;
  },
  (error) => {
    // Global Error Handling
    if (error.response) {
      // The server responded with a status code outside the 2xx range
      console.error(
        `[API Error] Status: ${error.response.status} -`,
        error.response.data,
      );

      if (error.response.status === 401) {
        console.warn("Unauthorized access - potential invalid token.");
      }
    } else if (error.request) {
      // The request was made but no response was received
      console.error(
        "[API Error] No response received from server:",
        error.request,
      );
    } else {
      // Something happened in setting up the request
      console.error("[API Error] Message:", error.message);
    }

    return Promise.reject(error);
  },
);
